import React from "react";
import { GetCurrentUser } from "../utills/DefaultFunction"; 
import { useState } from "react";
import { useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoutes = () => {
  // let user = GetCurrentUser();
  const [user, setUser] = useState(GetCurrentUser());
  let exp = localStorage.getItem("expiryTime");
  const currentTime = Date.now();

  useEffect(() => {
    const handleStorageChange = () => {
      // Update the user state when the session storage changes
      setUser(GetCurrentUser());
    };

    // Listen for changes to session storage
    window.addEventListener("storage", handleStorageChange);

    // Clean up the event listener when the component is unmounted
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  const check = () => {
    if (user) {
      if (currentTime > exp) {
        localStorage.removeItem("user");
        alert("Your session has been expired!");
        // navigate(STRINGS.ROUTES.ROOT)
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  };

  return check() ? <Outlet /> : <Navigate to="/" />;
};

export default ProtectedRoutes;
